import { useEffect, useState } from "react";
import DarkButton from "components/actions/DarkButton";
import PenEditIcon from "components/icons/PenEditIcon";
import PlusIcon from "components/icons/PlusIcon";
import { FaArrowLeft } from "react-icons/fa";
// import { AiOutlineUser } from "react-icons/ai";
import { LuHouse } from "react-icons/lu";
import InputField from "components/fields/InputField";
import ImageUploader from "./image";
import GrayButton from "components/actions/GrayButton";
import HouseholdMultiSelect from "./multiselect";
import DeleteIcon from "components/icons/DeleteIcon";
import AtriumApi from "api";
import Avatar from "components/avatar";
// import { setNestedObjectValues } from "formik";
import Loader from "components/loader/Loader";
import toast from "react-hot-toast";
import ConfirmationDialog from "../confirmation-dialog";

const HouseHold = ({ user }) => {
  const [showAddHousehold, setShowAddHousehold] = useState(false);
  const [showNewHouseholdForm, setShowNewHouseholdForm] = useState(false);
  const [isEditingMember, setIsEditingMember] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [allergyFields, setAllergyFields] = useState([""]);

  const [usersList, setUsersList] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);

  const [houseHoldName, setHouseHoldName] = useState("");
  const [houseHoldImageFile, setHouseHoldImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);

  const [houseHoldsList, setHouseHoldsList] = useState([]);
  const [selectedHousehold, setSelectedHousehold] = useState(null);

  const [houseHoldsLsLoading, setHouseHoldsLsLoading] = useState(true);
  const [usersLoading, setUsersLoading] = useState(false);

  const [loading, setLoading] = useState(false);

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    message: "",
    onConfirm: () => {},
  });

  const getHouseHoldsByUser = async () => {
    setHouseHoldsLsLoading(true);
    try {
      const response = await AtriumApi.get(
        `/v2/households/household/${user?.id}`
      );
      if (response) {
        setHouseHoldsList(response?.data?.data);
      }
    } catch (error) {
      console.log("Error", error);
    } finally {
      setHouseHoldsLsLoading(false);
    }
  };

  const getUsersByHouseHold = async (id) => {
    setUsersLoading(true);
    try {
      const response = await AtriumApi.get(
        `/v2/households/users/${id}?currentUserId=${user?.id}`
      );
      if (response) {
        setSelectedUsers(
          response?.data?.data?.map((user) => ({
            id: user?.userHouseholdUser?.id,
            name:
              user?.userHouseholdUser?.firstName +
              " " +
              user?.userHouseholdUser?.lastName,
            role: user?.userHouseholdUser?.role,
            avatar: { url: user?.userHouseholdUser?.avatar },
            email: user?.userHouseholdUser?.email,
            phone: user?.userHouseholdUser?.phone,
            isPrimary: user?.isPrimary || false,
            userDetails: {
              relationshipText:
                user?.userHouseholdHousehold?.relationshipText || "",
              schoolGrade: user?.userHouseholdHousehold?.schoolGrade || "",
              allergies: user?.allergies || [],
            },
          }))
        );
      }
    } catch (error) {
      console.log("Error", error);
    } finally {
      setUsersLoading(false);
    }
  };

  const handleEditMember = (member) => {
    setSelectedMember(member);
    setIsEditingMember(true);
  };

  const handleRemoveUser = (id) => {
    setConfirmationDialog({
      open: true,
      message: "You want to remove this user?",
      onConfirm: async () => {
        const updatedFields = selectedUsers?.filter((u) => u?.id !== id);
        setSelectedUsers(updatedFields);
        toast.success("User removed successfully.");
        setConfirmationDialog({
          open: false,
          message: "",
          onConfirm: () => {},
        });
      },
    });
  };

  const handleCancelEdit = () => {
    if (selectedHousehold) {
      setShowAddHousehold(false);
      setShowNewHouseholdForm(false);
      setIsEditingMember(false);
    } else {
      setShowNewHouseholdForm(false);
      setShowAddHousehold(true);
    }
    setSelectedUsers([]);
    setHouseHoldName("");
    setHouseHoldImageFile(null);
    setImagePreview(null);
    setSelectedHousehold(null);
  };

  useEffect(() => {
    const fetchAllUsers = async () => {
      try {
        const response = await AtriumApi.get("/v1/users?page=1&status=active");
        if (response) {
          setUsersList(response?.data?.users);
        }
      } catch (error) {
        console.log("fetching all users error", error);
      }
    };
    fetchAllUsers();
  }, []);

  // Handle updating userDetails fields
  const handleUserDetailChange = (field, value) => {
    setSelectedMember((prev) => ({
      ...prev,
      userDetails: {
        ...prev.userDetails,
        [field]: value,
      },
    }));
  };

  // Allergy handlers
  const handleAddAllergy = () => {
    setSelectedMember((prev) => ({
      ...prev,
      userDetails: {
        ...prev.userDetails,
        allergies: [...prev.userDetails.allergies, ""],
      },
    }));
  };

  const handleAllergyChange = (index, value) => {
    setSelectedMember((prev) => {
      const newAllergies = [...prev.userDetails.allergies];
      newAllergies[index] = value;
      return {
        ...prev,
        userDetails: {
          ...prev.userDetails,
          allergies: newAllergies,
        },
      };
    });
  };

  const handleRemoveAllergy = (index) => {
    setSelectedMember((prev) => ({
      ...prev,
      userDetails: {
        ...prev.userDetails,
        allergies: prev.userDetails.allergies.filter((_, i) => i !== index),
      },
    }));
  };

  // Save changes to the main members array
  const handleSave = () => {
    setSelectedUsers((prevMembers) =>
      prevMembers.map((member) =>
        member.id === selectedMember.id ? selectedMember : member
      )
    );
    setIsEditingMember(false);
  };

  // Make primary functionality
  const handleMakePrimary = () => {
    setSelectedUsers((prevMembers) =>
      prevMembers.map((member) => ({
        ...member,
        isPrimary: member.id === selectedMember.id,
      }))
    );
    setIsEditingMember(false);
  };

  useEffect(() => {
    getHouseHoldsByUser();
  }, [user.id]);

  useEffect(() => {
    if (selectedMember) {
      setAllergyFields(selectedMember.userDetails.allergies || []);
    }
  }, [selectedMember]);

  useEffect(() => {
    if (selectedHousehold) {
      setHouseHoldName(selectedHousehold?.name);
      setImagePreview(selectedHousehold?.avatar);
    }
  }, [selectedHousehold]);

  const handleSaveHousehold = (e) => {
    e.preventDefault();

    setLoading(true);

    const formData = new FormData();

    formData.append("name", houseHoldName);
    formData.append("avatar", houseHoldImageFile || imagePreview);
    formData.append("userDetails", JSON.stringify(selectedUsers));

    formData.append(
      "primaryContactId",
      selectedUsers.find((u) => u.isPrimary)?.id || user?.id
    );
    formData.append(
      "primaryContactName",
      selectedUsers.find((u) => u.isPrimary)?.name ||
        user?.firstName + " " + user?.lastName
    );

    const config = {
      headers: { "Content-Type": "multipart/form-data" },
    };

    const request = selectedHousehold?.id
      ? AtriumApi.put(
          `/v2/households/${selectedHousehold?.id}`,
          formData,
          config
        )
      : AtriumApi.post("/v2/households", formData, config);

    request
      .then((response) => {
        e.target.classList.remove("animate-pulse");

        if (response.status === 422) {
          toast.error(response.data.message);
        } else if (response.status === 201 || response.status === 200) {
          toast.success(
            `Household ${
              selectedHousehold?.id ? "updated" : "created"
            } successfully.`
          );
          setShowAddHousehold(false);
          setShowNewHouseholdForm(false);
          setIsEditingMember(false);
          getHouseHoldsByUser();
        } else {
          throw new Error("unexpected response");
        }
      })
      .catch((error) => {
        toast.error(error?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleDeleteHousehold = () => {
    setConfirmationDialog({
      open: true,
      message: "You want to delete this household?",
      onConfirm: async () => {
        try {
          await AtriumApi.delete(
            `/v2/households/${selectedHousehold?.id}`
          ).then(() => {
            toast.success("Household deleted successfully.");
            setShowAddHousehold(false);
            setShowNewHouseholdForm(false);
            setIsEditingMember(false);
            getHouseHoldsByUser();
          });
        } catch (err) {
          toast.error(err?.data?.message || "An error occurred");
        } finally {
          setConfirmationDialog({
            open: false,
            message: "",
            onConfirm: () => {},
          });
        }
      },
    });
  };

  useEffect(() => {
    if (!selectedHousehold) {
      setSelectedUsers([
        {
          id: user?.id,
          name: user?.firstName + " " + user?.lastName,
          role: user?.role,
          avatar: { url: user?.avatar?.url },
          email: user?.email,
          phone: user?.phone,
          isPrimary: true,
          userDetails: {
            relationshipText: "",
            schoolGrade: "",
            allergies: [],
          },
        },
      ]);
    }
  }, [selectedHousehold]);

  return (
    <div>
      {!showAddHousehold && !showNewHouseholdForm && !isEditingMember && (
        <>
          <div className="flex justify-end mt-2 mb-6">
            <DarkButton
              customClass="px-2 md:px-2"
              size="lg"
              disabled={user?.status !== "active"}
              onClick={() => {
                setShowAddHousehold(true);
                setSelectedHousehold(null);
              }}
            >
              <PlusIcon /> Add Household
            </DarkButton>
          </div>

          <div>
            <h1 className="text-gray-400 text-[16px] border-b border-gray-200 pb-2">
              Households
            </h1>
          </div>

          {houseHoldsLsLoading ? (
            <div className="flex justify-center py-5">
              <Loader />
            </div>
          ) : houseHoldsList?.length > 0 ? (
            houseHoldsList?.map((item, index) => (
              <div
                key={index}
                className="flex justify-between items-center py-4 border-b border-gray-200"
              >
                <p className="text-[#A3AED0] text-[16px]">{item?.name}</p>
                <p
                  onClick={() => {
                    setShowNewHouseholdForm(true);
                    setSelectedHousehold(item);
                    getUsersByHouseHold(item?.id);
                  }}
                  className="bg-[#2B3674] w-8 h-8 rounded-lg flex justify-center items-center cursor-pointer"
                >
                  <PenEditIcon className="text-white" />
                </p>
              </div>
            ))
          ) : (
            <div className="text-center py-5">
              <p className="text-[#A3AED0] text-[16px]">No Household found.</p>
            </div>
          )}
        </>
      )}

      {showAddHousehold && !showNewHouseholdForm && !isEditingMember && (
        <div className="space-y-6 relative">
          <DarkButton size="lg" onClick={() => setShowAddHousehold(false)}>
            <span className="flex items-center gap-1">
              <FaArrowLeft className="mr-2" />
              Back
            </span>
          </DarkButton>

          <div className="relative">
            <p className="text-[#1B2559] dark:text-white font-medium text-sm mb-1">
              Whose Household Would you like {user?.firstName} {user?.lastName}{" "}
              to Join
            </p>
            <HouseholdMultiSelect
              currentUser={user}
              users={usersList}
              selectedMembers={selectedUsers}
              setSelectedMembers={setSelectedUsers}
            />
          </div>

          <hr className="border-gray-200" />

          <button
            className="w-full bg-[#2B3674] text-white py-3 rounded-xl flex items-center justify-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed"
            onClick={() => setShowNewHouseholdForm(true)}
            disabled={selectedUsers?.length < 2}
          >
            <LuHouse />
            <span>
              {selectedHousehold ? "Update" : "Create a new"} Household with
              selected members
            </span>
          </button>

          {/* <div className="border border-gray-200 rounded-xl px-4 py-3 flex items-center cursor-pointer justify-center space-x-2">
            <span className="text-lg">
              <AiOutlineUser />
            </span>
            <span className="text-gray-800 dark:text-white">
              Create a new person
            </span>
          </div> */}
        </div>
      )}

      {showNewHouseholdForm && !isEditingMember && (
        <div className="space-y-6">
          <InputField
            label="Household Name"
            id="householdName"
            type="text"
            placeholder="Household Name"
            value={houseHoldName || ""}
            onChange={(e) => setHouseHoldName(e.target.value)}
          />
          <ImageUploader
            imagePreview={imagePreview}
            setImagePreview={setImagePreview}
            setImageFile={setHouseHoldImageFile}
          />

          <div className="border border-gray-200 rounded-xl px-4 py-3 flex flex-col gap-4">
            {/* <div className="flex items-center justify-between border-b last:border-b-0 pb-4">
              <div className="flex items-center space-x-2">
                <div className="w-12 h-12 rounded-full">
                  <Avatar user={user} size="md" />
                </div>
                <div>
                  <p className="text-[#2B3674] dark:text-white text-[14px]">
                    {user?.firstName} {user?.lastName}
                  </p>
                  <p className="text-[#8F9BBA] text-[12px]">{user?.email}</p>
                </div>
              </div>

              <div className="flex items-center flex-col gap-2">
                {!selectedUsers.some((user) => user.isPrimary) && (
                  <div className="bg-[#e6faf5] px-2 py-1 rounded-[10px]">
                    <p className="text-[#01B574] text-[14px]">Primary</p>
                  </div>
                )}

                <div className="flex items-center gap-2 px-2">
                  <div
                    onClick={() =>
                      handleEditMember({
                        ...user,
                        isPrimary: selectedUsers?.some(
                          (user) => user.isPrimary
                        ),
                        userDetails: {
                          relationshipText: "",
                          schoolGrade: "",
                          allergies: [],
                        },
                      })
                    }
                  >
                    <PenEditIcon className="text-[#2B3674] dark:text-white" />
                  </div>
                  <div>
                        <DeleteIcon className="text-[#EB5757] " />
                      </div>
                </div>
              </div>
            </div> */}
            {usersLoading ? (
              <div className="flex justify-center py-5">
                <Loader />
              </div>
            ) : selectedUsers?.length > 0 ? (
              selectedUsers?.map((member) => (
                <div
                  key={member?.id}
                  className="flex items-center justify-between border-b last:border-b-0 pb-4"
                >
                  <div className="flex items-center space-x-2">
                    <div className="w-12 h-12 rounded-full">
                      <Avatar user={member} size="md" />
                    </div>
                    <div>
                      <p className="text-[#2B3674] dark:text-white text-[14px]">
                        {member?.name ||
                          member?.firstName + " " + member?.lastName}
                      </p>
                      <p className="text-[#8F9BBA] text-[12px]">
                        {member?.email}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-center flex-col gap-2">
                    {member?.isPrimary && (
                      <div className="bg-[#e6faf5] px-2 py-1 rounded-[10px]">
                        <p className="text-[#01B574] text-[14px]">Primary</p>
                      </div>
                    )}

                    <div className="flex items-center gap-2 px-2">
                      <div onClick={() => handleEditMember(member)}>
                        <PenEditIcon className="text-[#2B3674] dark:text-white" />
                      </div>
                      {!member?.isPrimary && member?.id !== user?.id && (
                        <div onClick={() => handleRemoveUser(member?.id)}>
                          <DeleteIcon className="text-[#EB5757]" />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="flex items-center justify-center">
                <p className="text-[#2B3674] dark:text-white text-[14px]">
                  No user selected
                </p>
              </div>
            )}
          </div>

          <div className="flex items-center flex-wrap justify-end gap-2">
            {selectedHousehold && (
              <DarkButton
                kind="danger"
                size="lg"
                onClick={handleDeleteHousehold}
              >
                Delete Household
              </DarkButton>
            )}
            <DarkButton
              onClick={() => {
                setShowNewHouseholdForm(false);
                setShowAddHousehold(true);
              }}
              size="lg"
            >
              Add person in household
            </DarkButton>
          </div>

          <div className="border-b border-gray-200" />
          <div className="flex items-center justify-end gap-2">
            <GrayButton size="lg" onClick={handleCancelEdit}>
              Cancel
            </GrayButton>
            <DarkButton
              onClick={handleSaveHousehold}
              size="lg"
              disabled={!houseHoldName || selectedUsers?.length < 2 || loading}
            >
              {loading ? "Saving..." : "Save Household"}
            </DarkButton>
          </div>
        </div>
      )}

      {isEditingMember && selectedMember && (
        <div>
          <DarkButton size="lg" onClick={() => setIsEditingMember(false)}>
            <span className="flex items-center gap-1">
              <FaArrowLeft className="mr-2" />
              Back
            </span>
          </DarkButton>

          <div className="flex justify-end gap-4 my-3">
            {selectedMember?.id !== user?.id && !selectedMember?.isPrimary && (
              <button
                onClick={() => {
                  handleRemoveUser(selectedMember?.id);
                  setIsEditingMember(false);
                }}
                className="text-[#EE5D50] rounded-[15px] border border-[#EE5D50] px-3 py-1"
              >
                Remove
              </button>
            )}
            {(!selectedUsers.some((user) => user.isPrimary) &&
              selectedMember?.id === user?.id) ||
            selectedMember?.isPrimary ? (
              <div className="bg-[#e6faf5] px-3 py-1 rounded-[13px]">
                <p className="text-[#01B574] text-[16px]">Primary</p>
              </div>
            ) : (
              <button
                onClick={handleMakePrimary}
                className="text-[#45AF82] rounded-[15px] border border-[#45AF82] px-3 py-1"
              >
                Make a primary
              </button>
            )}
          </div>

          <div className="grid gap-3">
            <InputField
              label="Assign relationship"
              type="text"
              placeholder="Relationship"
              value={selectedMember?.userDetails?.relationshipText || ""}
              onChange={(e) =>
                handleUserDetailChange("relationshipText", e.target.value)
              }
            />
            <InputField
              label="School grade"
              type="text"
              placeholder="School grade"
              value={selectedMember?.userDetails?.schoolGrade || ""}
              onChange={(e) =>
                handleUserDetailChange("schoolGrade", e.target.value)
              }
            />
            {selectedMember?.userDetails?.allergies?.map((allergy, index) => (
              <div key={index} className="flex items-center">
                <div className="flex-1">
                  <InputField
                    type="text"
                    placeholder="Allergies"
                    value={allergy}
                    onChange={(e) => handleAllergyChange(index, e.target.value)}
                  />
                </div>
                <button
                  onClick={() => handleRemoveAllergy(index)}
                  className="ml-2 bg-transparent border-none cursor-pointer text-lg text-red-500"
                  aria-label="Remove Allergy"
                >
                  ✕
                </button>
              </div>
            ))}
          </div>

          <div className="flex mt-4 justify-end">
            <DarkButton
              size="lg"
              onClick={handleAddAllergy}
              disabled={allergyFields?.includes("")}
            >
              Add Allergy
            </DarkButton>
          </div>

          <div className="border-b border-gray-200 my-4" />
          <div className="flex items-center justify-end gap-2">
            <GrayButton size="lg" onClick={() => setIsEditingMember(false)}>
              Cancel
            </GrayButton>
            <DarkButton size="lg" onClick={handleSave}>
              Save
            </DarkButton>
          </div>
        </div>
      )}
      <ConfirmationDialog
        isOpen={confirmationDialog.open}
        message={confirmationDialog.message}
        onClose={() => setConfirmationDialog({ open: false, message: "" })}
        onConfirm={confirmationDialog.onConfirm}
      />
    </div>
  );
};

export default HouseHold;
